module.exports = __webpack_public_path__ + "static/media/events.0bec8a27.svg";